import React from "react";

// 3rd party libraries
import { Box, Typography, Container } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";

import { useFetchAllSearches } from "@/hooks";

// style things
import { constants as styleConstants } from "@/styles/config";
import { MySubmissions, QuotasSection, ActiveSearchesCompactSection } from "./sections";

const useStyles = makeStyles(() => ({
  container: {
    padding: styleConstants.desktopDrawerClosedWidth / 2,
    maxWidth: "100vw",
    minHeight: "100vh"
  },
  content: {
    marginTop: 20,
    marginLeft: styleConstants.desktopDrawerClosedWidth
  },

  pageTitle: {
    marginLeft: styleConstants.desktopDrawerClosedWidth
  },
  titleText: { fontSize: 24, fontWeight: "bold" }
}));

const Home = () => {
  const classes = useStyles();

  const { loading: isLoadingAllSearches, allSearches, fetchAllSearches } = useFetchAllSearches();

  return (
    <Container className={classes.container} maxWidth={false}>
      <Box className={classes.pageTitle}>
        <Typography className={classes.titleText}>Recruiter Home</Typography>
      </Box>

      <Box className={classes.content}>
        <QuotasSection />

        <Box my={2}></Box>

        <Box sx={{ display: "flex" }}>
          <ActiveSearchesCompactSection
            allSearches={allSearches}
            isLoading={isLoadingAllSearches}
            fetchAllSearches={fetchAllSearches}
          />

          <Box mx={2}></Box>

          <MySubmissions />
        </Box>

        <Box my={2}></Box>
      </Box>
    </Container>
  );
};

export { Home };
